import { Component, EventEmitter, Input, OnInit, Output, DestroyRef, inject} from '@angular/core'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { FormControl } from '@angular/forms'

import { FetchService } from '../../services/fetch.service'
import { CommonService } from '@app/shared/services/common.service'
import { NgxSpinnerService } from 'ngx-spinner'

@Component({ selector: 'app-ticket-uploader', templateUrl: './ticket-uploader.component.html', styleUrls: ['./ticket-uploader.component.scss'], standalone: false })
export class TicketUploaderComponent implements OnInit {
  private destroyRef = inject(DestroyRef)
  @Output() changed = new EventEmitter<string | null>()
  @Input() label: string | null = null
  @Input() areaMode: boolean = true
  @Input() disabled: boolean = false
  @Input() form: FormControl

  /** When click on the button open the upload file init of false for block  */
  @Input() openTheFileUploadOnClick: boolean = true

  /** File upload type */
  @Input() fileType: string = 'passes'

  /** Init when we need to send upload tickets query contain additional */
  @Input() additionalData: any

  /** Import tickets title */
  @Input() importTitle: string = 'COMMON.BUTTONS.IMPORT_TICKETS'

  model: string | null

  /** Save the last selected file data for use it in parent component */
  lastSelectedFile: any

  constructor(private fetchService: FetchService, private commonService: CommonService, private spinner: NgxSpinnerService) {}
  loading: boolean = false
  @Output() loadingChange = new EventEmitter<boolean>()

  @Output() onClick = new EventEmitter()

  ngOnInit(): void {
    if (this.form) {
      this.model = this.form.value
      this.form.valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((value) => {
        this.model = value
      })
    }
  }
  onChange(e: any) {
    this.lastSelectedFile = e

    if (
      (e?.target?.files.length && this.additionalData == null) ||
      (e?.target?.files.length && Object.keys(this.additionalData)?.length > 0 && this.commonService.checkObjectValues(this.additionalData))
    ) {
      this.spinner.show()
      this.model = null
      this.loading = true
      this.loadingChange.emit(true)

      const data: any = {
        file: e.target.files[0],
        uploadCategory: this.fileType,
      }

      this.fetchService.post('/file/upload', data).subscribe((e: any) => {
        this.loading = false
        if (e.success) {
          this.set(e.data.link)
        }
        this.spinner.hide()
        this.loadingChange.emit(false)
      })
    }
  }
  set(link: string | null) {
    this.model = link
    this.form.setValue(this.model)
    this.changed.emit(this.model)
  }
  reset(e: Event) {
    e.preventDefault()
    this.set(null)
    this.changed.emit(null)
  }
}
